export default interface BaseStorageInterface {
    setItem(value: string): void,
    getItem():string | null,
    removeItem(): void,
    type: StorageType,
    storageKey: string
}

export enum StorageType {
    "localStorage" = "localStorage",
    "sessionStorage" = "sessionStorage",
    "cookieStorage" = "cookieStorage",
}

export const DEFAULT_STORAGE_KEY_NAME = "PluginClient";
